/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconJewishStar = createReactComponent("jewish-star", "IconJewishStar", [
  [
    "path",
    { d: "M12 2l3 5h6l-3 5l3 5h-6l-3 5l-3 -5h-6l3 -5l-3 -5h6z", key: "svg-0" }
  ]
]);

export { IconJewishStar as default };
//# sourceMappingURL=IconJewishStar.js.map
